module.exports = __webpack_public_path__ + "img/logo2-2.679a3bf1.png";